import { useTranslation } from 'react-i18next';
import { Card, CardBody } from 'reactstrap';

import { Encounter } from 'api/periodReports/type';

const EncounterElement: React.FC<{ encounter: Encounter }> = ({ encounter }) => {
  const { t } = useTranslation();
  return (
    <Card
      className="card shadow-hover"
      style={{ backgroundColor: encounter.fixed ? 'rgba(28, 255, 111, 0.2)' : 'inherit' }}
    >
      <CardBody>
        <div className="d-lg-flex align-items-center">
          {/* Column 1 */}
          <div className="col-lg-1 text-center">
            <div>
              {encounter.pest_traces ? (
                <i title="Discovered pest traces" className="ri-footprint-fill text-warning fs-1" />
              ) : (
                <i title="Pest discovered" className="ri-mickey-fill text-info fs-1" />
              )}
            </div>
          </div>

          {/* Column 2 */}
          <div className="col-lg-2">
            <div className="ms-4">
              <h5 className="fs-16 text-center mb-2">{encounter.discovery_date}</h5>
              <p className="text-muted text-center mb-0">{t('EcnounterList.accordion.accordion-inner.encount-data')}</p>
            </div>
          </div>

          {/* Column 3 */}
          <div className="col-lg-3">
            <div className="ms-3">
              {encounter.pest_traces ? (
                <div>
                  <h5 className="fs-16 mb-2 text-center">{encounter.pest_traces}</h5>
                  <p className="text-muted text-center mb-0">
                    {t('EcnounterList.accordion.accordion-inner.pest.pest-traces')}
                  </p>
                </div>
              ) : (
                <div>
                  <h5 className="fs-16 mb-2 text-center">
                    {encounter.pest_name} - ({encounter.amount} pcs.)
                  </h5>
                  <p className="text-muted text-center mb-0">
                    {t('EcnounterList.accordion.accordion-inner.pest.amount')}
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Column 4 */}
          <div className="col-lg-2">
            <div className="ms-4">
              <h5 className="fs-16 text-center mb-2">{encounter.witness}</h5>
              <p className="text-muted text-center mb-0">{t('EcnounterList.accordion.accordion-inner.witness')}</p>
            </div>
          </div>

          {/* Column 5 */}
          <div className="col-lg-2">
            <div className="ms-4">
              {encounter.inspection_date !== 'Не інспектовано' ? (
                <h5 className="fs-16 text-center mb-2">{encounter.inspection_date}</h5>
              ) : (
                <h5 className="fs-16 text-center text-danger mb-2">
                  {t('EcnounterList.accordion.accordion-inner.no-inspected')}
                </h5>
              )}
              <p className="text-muted text-center mb-0">
                {t('EcnounterList.accordion.accordion-inner.inspection-date')}
              </p>
            </div>
          </div>

          {/* Column 6 */}
          <div className="col-lg-2">
            <div className="ms-4">
              {encounter.inspection_date !== 'Не інспектовано' ? (
                <h5 className="fs-16 text-center mb-2">{encounter.inspector}</h5>
              ) : (
                <h5 className="fs-16 text-center text-danger mb-2">
                  {t('EcnounterList.accordion.accordion-inner.no-inspected')}
                </h5>
              )}
              <p className="text-muted text-center mb-0">{t('EcnounterList.accordion.accordion-inner.inspector')}</p>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default EncounterElement;
